import { DatePipe } from "@angular/common";
import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { NgxSpinnerService } from "ngx-spinner";
import { SanitizeHtmlPipe } from "src/services/desc.pipe";
import { ServicesService } from "src/services/services.service";
import { SocketService } from "src/services/socket.service";
import Swal from "sweetalert2";
import { ImageOptionsDialogComponent } from "./image-options-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SecureStorageService } from "src/services/secure-storage.service";
import { AnalyticsService } from "src/services/analytics.service";
import { EncryptionService } from "src/services/encryption.service";

export interface PopData {
  event_id: any;
}

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
  standalone: false,
})
export class RegistrationComponent {
  event_id: any;
  refercode: any;
  event_data: any;
  user_id: any;
  event_name: any;
  event_type: any;
  description: any;
  address: any;
  reg_fee: any;
  from_date: any;
  to_date: any;
  event_logo: any;
  event_image: any;
  from_time: any;
  to_time: any;
  status: any;
  registration: any;
  payment_ss: any;
  is_active: any;
  ELEMENT_DATA: any[] = [];
  reg_result: any;
  formData: any = {};
  minDate: any;
  maxDate: any;
  company_ad: any;
  imageChangedEvent: any = "";
  croppedImage: SafeUrl | null = null;
  currentUploadType: "id_proof" | "images" | "payment_ss" | null = null;
  showCropper = false;
  company_ad_text: any;

  // --- OTP Properties ---
  showOtpScreen: boolean = false; // Controls the view
  otpSent: boolean = false; // Tracks if OTP was successfully sent
  otpValue: string = ""; // Model for OTP input
  otpContact: string = ""; // The mobile/email to send OTP to
  otpFieldConfig: any;
  isOtpLocked: boolean = false;

  currentField: "id_proof" | "images" | "payment_ss" | null = null;

  getImagePathForField(field: string): string {
    if (field === "payment_ss") return this.paymentPath;
    if (field === "id_proof") return this.proofPath;
    if (field === "images") return this.imagePath;
    return ""; // Return empty if no match
  }

  @ViewChild("cameraInput") cameraInput!: ElementRef;
  @ViewChild("galleryInput") galleryInput!: ElementRef;
  openImageOptions(type: "id_proof" | "images" | "payment_ss") {
    this.currentField = type; // Store the type (e.g., 'payment_ss')

    const dialogRef = this.dialog.open(ImageOptionsDialogComponent, {
      width: "300px",
      panelClass: "custom-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      setTimeout(() => {
        if (result === "camera") {
          this.cameraInput.nativeElement.click();
        } else {
          this.galleryInput.nativeElement.click();
        }
      }, 300);
    });
  }
  // openCamera() {
  //   this.dialog.closeAll();

  //   setTimeout(() => {
  //     this.dialog.closeAll();
  //     this.cameraInput?.nativeElement.click();
  //   }, 100);
  // }

  // openGallery() {
  //   this.dialog.closeAll();

  //   setTimeout(() => {
  //     this.galleryInput?.nativeElement.click();
  //   }, 100);
  // }

  handleFileSelection(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    this.dialog.closeAll();

    // Choose the correct preview method based on the field we stored earlier
    if (this.currentField === "id_proof") {
      this.previewpproof(files);
    } else if (this.currentField === "images") {
      this.previewpimage(files);
    } else if (this.currentField === "payment_ss") {
      this.preview_payment_image(files);
    }

    // Reset event so the same file can be picked again if needed
    event.target.value = "";
  }

  logofileURL!: string | ArrayBuffer | null;
  proofPath: any;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  imagePath: any;
  paymentPath: any = "";
  message!: string;
  tic_category: any;

  showImageField = false;
  showIdProofField = false;
  setting_data: any;
  success_msg: any;
  reg_whatsapp_msg: any;
  event_tic_category: any;
  isapproved = false;
  isover: boolean = false;
  isFull: boolean = false;
  card_data: any;
  card_image: any;
  total_reg: number = 0;
  registered_count: number = 0;
  created_by: any;
  decryptedData: any;

  constructor(
    private route: ActivatedRoute,
    private service: ServicesService,
    private spinner: NgxSpinnerService,
    private socket: SocketService,
    private router: Router,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private analyticsService: AnalyticsService,
    private secureStorage: SecureStorageService,
    private encryptService: EncryptionService,
  ) { }

  ngOnInit(): void {
    // const currentUrl = window.location.href;
    // sessionStorage.setItem('savedUrl', currentUrl);

    const hash = window.location.hash; // "#/Registration/19/PRAV2086/426"
    const cleanPath = hash.replace(/^#\//, ""); // "Registration/19/PRAV2086/426"
    sessionStorage.setItem("savedUrl", cleanPath);
    this.route.paramMap.subscribe((params: any) => {
      this.analyticsService.trackEvent("Registration_Page_Reload", {
        button: "page_visit",
      });

      this.event_id = params.get("event_id");
      this.refercode = params.get("refercode");
      this.created_by = params.get("created_by");

      this.Get_Reg_Setting(this.event_id);

      this.Get_Event_By_Id(this.event_id);
      this.Get_Card(this.event_id);
      this.Get_Setting(this.event_id);
      this.Get_Tic_Category(this.event_id);
    });

    this.route.queryParams.subscribe((params) => {
      if (params["data"]) {
        try {
          const decrypted = this.encryptService.decrypt(params["data"]);
          this.decryptedData = JSON.parse(decrypted);

          console.log("Decrypted:", this.decryptedData);
        } catch (err) {
          console.error("Invalid encrypted data");
          alert("Invalid data provided in URL");
          window.location.href = "https://aieventzo.com";
        }
      }
    });
  }

  previewpproof(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.logofileURL = reader.result;
      this.imgType = this.event_id + "/id_proof";
      this.service
        .uploadimage(this.logofileURL, this.imgType)
        .subscribe((data: any) => {
          this.proofPath = data["image_name"];
        });
    };
  }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = this.event_id + "/images";
      this.service
        .uploadimage(this.imagefileURL, this.imgType)
        .subscribe((data: any) => {
          this.imagePath = data["image_name"];
        });
    };
  }

  preview_payment_image(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = this.event_id + "/payment_ss";
      this.service
        .uploadimage(this.imagefileURL, this.imgType)
        .subscribe((data: any) => {
          this.paymentPath = data["image_name"];
        });
    };
  }

  Get_Tic_Category(event: any) {
    this.service.get_ticket_category(event).subscribe((data: any) => {
      this.event_tic_category = data.data.map((item: any) => ({
        ...item,
        quantity: item.quantity || 0,
        max_allowed: Number(item.max_allowed) || 0,
      }));

      this.isFull = this.event_tic_category.every(
        (item: any) => item.disable_category,
      );
    });
  }

  onFileSelected(event: Event, type: "id_proof" | "images" | "payment_ss") {
    this.imageChangedEvent = event;
    this.currentUploadType = type;
    this.showCropper = true; // display cropper UI
  }

  // capture cropped image
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl!);
  }

  // when cropper ready
  cropperReady() {
    console.log("Cropper ready!");
  }

  // finalize cropping and upload
  uploadCroppedImage() {
    if (!this.croppedImage || !this.currentUploadType) return;

    fetch((this.croppedImage as any).changingThisBreaksApplicationSecurity)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          const base64Data = reader.result as string;
          this.imgType = `${this.event_id}/${this.currentUploadType}`;
          this.service
            .uploadimage(base64Data, this.imgType)
            .subscribe((data: any) => {
              if (this.currentUploadType === "id_proof") {
                this.proofPath = data["image_name"];
              } else if (this.currentUploadType === "images") {
                this.imagePath = data["image_name"];
              } else if (this.currentUploadType === "payment_ss") {
                this.paymentPath = data["image_name"];
              }
              this.showCropper = false; // hide cropper after upload
              this.croppedImage = null;
              this.currentUploadType = null;
            });
        };
      });
  }

  Get_Event_By_Id(event_id: any) {
    this.service.get_event_by_id(event_id).subscribe((data: any) => {
      this.event_data = data.data;
      this.event_id = this.event_data[0].event_id;
      this.user_id = this.event_data[0].user_id;
      this.event_name = this.event_data[0].event_name;
      this.event_type = this.event_data[0].event_type;
      this.description = this.event_data[0].description;
      this.address = this.event_data[0].address;
      this.reg_fee = this.event_data[0].reg_fee;
      this.from_date = this.event_data[0].from_date;
      this.to_date = this.event_data[0].to_date;
      this.event_logo = this.event_data[0].event_logo;
      this.event_image = this.event_data[0].event_image;
      this.payment_ss = this.event_data[0].payment_ss;
      this.from_time = this.event_data[0].from_time;
      this.to_time = this.event_data[0].to_time;
      this.status = this.event_data[0].status;
      this.registration = this.event_data[0].registration;
      this.registered_count =
        parseInt(this.event_data[0].registered_count) || 0;
      this.total_reg = parseInt(this.event_data[0].total_reg) || 0;
      this.is_active = this.event_data[0].is_active;
      this.analyticsService.pageTitleTag(this.event_name);

      // Create the to_date object correctly
      const to_date = new Date(this.to_date); // Correctly created date for 2024-12-20

      // Get today's date and normalize to midnight (00:00:00)
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize the time to 00:00:00 to focus only on the date part

      // Normalize the to_date to midnight as well (important for consistent comparisons)
      // Normalize the time to 00:00:00 to ignore time differences

      // Compare the dates (ignoring time part)
      if (to_date > today) {
        this.isover = false; // This will be set to true if to_date is after today
      } else {
        this.isover = true; // This will be set to false if to_date is not after today
      }
      if (this.registered_count >= this.total_reg) {
        this.isFull = true;
      }

      if (this.is_active == 1) {
        this.isapproved = true;
      }
    });
  }

  Get_Card(event_id: any) {
    this.service.get_card(event_id).subscribe((data: any) => {
      this.card_data = data.data;
      this.card_image = this.card_data[0].image1;
      this.company_ad = this.card_data[0].company_ad;
      this.company_ad_text = this.card_data[0].company_ad_text;
    });
  }

  hasPaymentScreenshotField(): boolean {
    return this.ELEMENT_DATA?.some(
      item => item.fields === 'payment_ss' && item.hide_show == 1
    );
  }

  Get_Reg_Setting(event_id: any) {
    this.ELEMENT_DATA = [];
    this.service.get_reg_setting(event_id).subscribe((data: any) => {
      this.reg_result = data.data;
      for (const item of this.reg_result) {
        this.ELEMENT_DATA.push({
          label: item.label,
          fields: item.fields,
          hide_show: item.hide_show == 1 ? true : false,
          require: item.require == 1 ? true : false,
          type: item.type,
          value: item.value?.toString().trim(),
        });
        if (item.type == "date") {
          const dates = item.value.split(" - ").map((date: any) => date.trim());
          if (dates.length === 2) {
            this.minDate = dates[0]; // '2025-03-05'
            this.maxDate = dates[1]; // '2025-03-12'
          }
        }
      }

      if (event_id == 47) {
        this.otpFieldConfig = this.ELEMENT_DATA.find(
          (e) => e.fields === "mobile" && e.hide_show,
        );
        if (!this.otpFieldConfig) {
          this.otpFieldConfig = this.ELEMENT_DATA.find(
            (e) => e.fields === "email" && e.hide_show,
          );
        }

        // If an OTP field is configured, show the OTP screen first
        if (this.otpFieldConfig) {
          this.showOtpScreen = true;
        } else {
          // If no specific OTP field is found, proceed to registration form directly
          this.showOtpScreen = false;
        }
      } else {
        this.showOtpScreen = false;
      }
    });
  }

  Get_Setting(event_id: any) {
    this.service.getsetting(event_id).subscribe((data: any) => {
      this.setting_data = data.data;
      this.success_msg = this.setting_data[0].success_msg;
      this.reg_whatsapp_msg = this.setting_data[0].reg_whatsapp_msg;
    });
  }

  sendOtp() {
    if (!this.otpContact) {
      Swal.fire(
        "Error",
        "Please enter your " + this.otpFieldConfig.label,
        "warning",
      );
      return;
    }

    this.analyticsService.trackEvent("otp_send_click", {
      event_category: "registration",
      event_label: "send_otp",
      page_title: "Registration Form",
      page_path: "/scan-me/registration",
      phone_country: "IN",
      debug_mode: true,
    });

    this.spinner.show();
    this.service.sendOtp(this.event_id, this.otpContact).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data.flag) {
          this.otpSent = true;
          // Swal.fire('Success', 'OTP has been sent to ' + this.otpContact, 'success');
        } else {
          Swal.fire("Error", data.msg || "Failed to send OTP.", "error");
        }
      },
      () => {
        this.spinner.hide();
        Swal.fire("Error", "An error occurred while sending OTP.", "error");
      },
    );
  }

  // New method to verify OTP
  verifyOtp() {
    if (!this.otpContact || !this.otpValue) {
      Swal.fire(
        "Error",
        "Please enter both " + this.otpFieldConfig.label + " and OTP.",
        "warning",
      );
      return;
    }

    this.analyticsService.trackEvent("otp_verified", {
      event_category: "registration",
      event_label: "otp_success",
      verification_method: "sms",
      page_title: "Registration Form",
      page_path: "/scan-me/registration",
      debug_mode: true,
    });

    this.spinner.show();
    this.service.verifyOtp(this.otpContact, this.otpValue).subscribe(
      (data: any) => {
        this.spinner.hide();
        if (data.flag) {
          Swal.fire(
            "Success",
            "OTP Verified. Proceeding to registration.",
            "success",
          );
          this.showOtpScreen = false; // Hide OTP screen
          this.formData[this.otpFieldConfig.fields] = this.otpContact; // Pre-fill the contact field

          if (+this.event_id === 47) {
            this.isOtpLocked = true;
          }
        } else {
          Swal.fire("Error", data.msg || "Invalid or expired OTP.", "error");
        }
      },
      () => {
        this.spinner.hide();
        Swal.fire(
          "Error",
          "An error occurred during OTP verification.",
          "error",
        );
      },
    );
  }

  formatDate(event: any, field: string) {
    if (event) {
      const formattedDate = this.datePipe.transform(event, "yyyy-MM-dd");
      this.formData[field] = formattedDate; // Assign formatted date
    }
  }

  increaseQuantity(item: any, field: string) {
    const max = item.max_allowed;

    if (!item.quantity) {
      item.quantity = 1;
    } else {
      if (max && item.quantity >= max) {
        Swal.fire(
          "Limit Reached",
          `Maximum ${max} tickets allowed for this category`,
          "warning",
        );
        return;
      }
      item.quantity++;
    }

    // Allow only one category
    this.resetOtherCategories(item);
    this.updateTicketCategoryData(field);
  }

  decreaseQuantity(item: any, field: string) {
    if (item.quantity && item.quantity > 0) {
      item.quantity--;
    }

    // If reduced to 0, no issue, just update
    this.updateTicketCategoryData(field);
  }

  onQuantityChange(item: any, field: string) {
    const max = item.max_allowed;

    if (!item.quantity || isNaN(item.quantity) || item.quantity < 0) {
      item.quantity = 0;
    }

    if (max && item.quantity > max) {
      item.quantity = max;

      Swal.fire(
        "Limit Reached",
        `Maximum ${max} tickets allowed for this category`,
        "warning",
      );
    }

    if (item.quantity > 0) {
      this.resetOtherCategories(item);
    }

    this.updateTicketCategoryData(field);
  }

  // 🔵 Reset all other categories quantity to ZERO
  resetOtherCategories(selectedItem: any) {
    this.event_tic_category.forEach((i: { quantity: number }) => {
      if (i !== selectedItem) {
        i.quantity = 0;
      }
    });
  }

  // 🔵 Your same logic — no changes needed
  updateTicketCategoryData(field: string) {
    const ticketList: any[] = [];
    let total = 0;
    let selectedCategoryId = 0;
    let ticket_quantity = 1;

    for (const item of this.event_tic_category) {
      if (item.quantity && item.quantity > 0) {
        ticketList.push({
          category: item.category,
          total_amount: item.total_amount,
          quantity: item.quantity,
          category_id: item.category_id, // ← ADD HERE
        });

        total += item.quantity * item.total_amount;

        selectedCategoryId = item.category_id; // ← STORE ID
        ticket_quantity = item.quantity; // ← STORE ID
      }
    }

    this.formData["category_id"] = selectedCategoryId; // ← SET HERE
    this.formData["ticket_quantity"] = ticket_quantity; // ← SET HERE
    this.formData[field] = ticketList;
    this.formData[field + "_total"] = total;
    this.reg_fee = total;
  }

  getTotalPrice(field: string): number {
    return this.formData[field + "_total"] || 0;
  }

  onCheckboxComma(field: string, option: string, checked: boolean) {
    let list = [];

    if (this.formData[field] && this.formData[field] !== "") {
      list = this.formData[field].split(","); // convert to array
    }

    if (checked) {
      if (!list.includes(option)) {
        list.push(option);
      }
    } else {
      list = list.filter((item: string) => item !== option);
    }

    this.formData[field] = list.join(","); // convert back to comma-separated
  }

  logFormData(submit_type: any) {
    console.log(this.formData);
    this.tic_category = this.formData.tic_category;

    const paymentRequired = this.ELEMENT_DATA.find(
      (e) => e.fields === "payment_ss" && e.hide_show && e.require,
    );
    if (paymentRequired && (!this.paymentPath || this.paymentPath == "")) {
      alert("Please Upload " + paymentRequired.label);
      return; // Stop further execution
    }

    const imageRequired = this.ELEMENT_DATA.find(
      (e) => e.fields === "image" && e.hide_show && e.require,
    );
    if (imageRequired && (!this.imagePath || this.imagePath == "")) {
      alert("Please Upload " + imageRequired.label);
      return; // Stop further execution
    }

    const proofidRequired = this.ELEMENT_DATA.find(
      (e) => e.fields === "id_proof" && e.hide_show && e.require,
    );
    if (proofidRequired && (!this.proofPath || this.proofPath == "")) {
      alert("Please Upload " + proofidRequired.label);
      return; // Stop further execution
    }

    const imageFields = ["payment_ss", "image", "id_proof"];

    const allRequiredFieldsFilled = this.ELEMENT_DATA.every((element) => {
      if (element.require && !imageFields.includes(element.fields)) {
        const value = this.formData[element.fields];

        return (
          value !== null && value !== undefined && String(value).trim() !== ""
        );
      }

      return true;
    });

    // Alert if any required field is not filled
    if (!allRequiredFieldsFilled) {
      alert("Please Fill All Required Fields.");
      return; // Stop further execution
    }

    this.spinner.show();

    this.service
      .Log(`${this.event_id}_registration_submit`, this.formData)
      .subscribe();

    console.log(this.tic_category);

    if (this.tic_category) {
      this.service
        .get_ticket_category_by_category(this.tic_category, this.event_id)
        .subscribe((data: any) => {
          if (data.flag) {
            const Ticket_data = data.data;
            const total_amount = Ticket_data[0].total_amount;

            if (total_amount) {
              this.reg_fee = total_amount;
            }
          }
          this.register(submit_type);
        });
    } else {
      this.register(submit_type);
    }
  }

  register(submit_type: any) {
    this.analyticsService.trackEvent("registration_submit_click", {
      event_category: "registration",
      event_label: "submit_form",
      page_title: "Registration Form",
      page_path: "/scan-me/registration",
      debug_mode: true,
    });

    if (this.reg_fee == 0) {
      if (this.decryptedData) {
        console.log(this.decryptedData.category_id);
        console.log(this.decryptedData.is_active);
        this.formData["category_id"] = this.decryptedData.category_id;
        this.formData["is_active"] = this.decryptedData.is_active;
      }

      this.service
        .add_registration(
          this.formData,
          this.event_id,
          this.proofPath,
          this.imagePath,
          this.paymentPath,
          this.tic_category,
          this.refercode,
          this.created_by,
        )
        .subscribe((data: any) => {
          if (data.flag === true) {
            this.formData.mem_id = data.mem_id;
            this.formData.id_card = data.id_card;

            if (data.send_whatsapp == "yes") {
              this.service
                .Generate_Card1(data.mem_id, this.event_id)
                .subscribe(() => {
                  this.service
                    .Send_Whatsapp(
                      this.formData,
                      this.event_id,
                      this.reg_whatsapp_msg,
                    )
                    .subscribe(() => {
                      if (submit_type == "checkin") {
                        var data = this.formData;
                        data.status = "checkin";
                        data.point = "Entry Point 1";
                        data.event_id = this.event_id;
                        this.service.docheckinout(data).subscribe((data) => {
                          this.service
                            .display(this.event_id)
                            .subscribe((registrationResponse: any) => {
                              var data1 = registrationResponse.result;

                              const payload = {
                                name: this.formData.name,
                                image:
                                  "https://aieventzo.com/upload/" +
                                  this.event_id +
                                  "/images/" +
                                  this.imagePath,
                              };
                              this.socket.sendMessage(data1);
                            });
                        });
                      }

                      this.socket.regrefresh(true);
                      this.spinner.hide();
                      this.goToSuccessPage(data, submit_type);
                    });
                });
            } else {
              if (submit_type == "checkin") {
                var data = this.formData;
                data.status = "checkin";
                data.point = "Entry Point 1";
                data.event_id = this.event_id;
                this.service.docheckinout(data).subscribe((data) => {
                  this.service.display(this.event_id).subscribe((data: any) => {
                    var data1 = data.result;

                    const payload = {
                      name: this.formData.name,
                      image:
                        "https://aieventzo.com/upload/" +
                        this.event_id +
                        "/images/" +
                        this.imagePath,
                    };
                    this.socket.sendMessage(data1);
                  });
                });
              }

              this.socket.regrefresh(true);
              this.spinner.hide();
              this.goToSuccessPage(data, submit_type);
            }
          } else if (data.flag === false) {
            this.spinner.hide();
            Swal.fire({
              title: data.msg,
              // html: data.msg,
              icon: "warning",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        });
    } else {
      this.service
        .add_registration_with_regfee(
          this.formData,
          this.event_id,
          this.proofPath,
          this.imagePath,
          this.paymentPath,
          this.tic_category,
          this.refercode,
          this.created_by,
        )
        .subscribe((data: any) => {
          if (data.flag === true) {
            this.formData.mem_id = data.mem_id;
            this.spinner.hide();

            this.secureStorage.setSession(
              "paymentData",
              JSON.stringify({
                event_id: this.event_id,
                mem_id: data.mem_id,
                tic_category: this.tic_category,
                price: this.reg_fee,
              }),
            );

            this.router.navigate(["/Payment"]);
          } else if (data.flag === false) {
            this.spinner.hide();
            Swal.fire({
              title: data.msg,
              // html: data.msg,
              icon: "warning",
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        });
    }
  }

  goToSuccessPage(data: any, submit_type: any) {
    this.router.navigate(['/registration-success'], {
      state: {
        registrationData: {
          name: this.formData.name,
          mem_id: this.formData.mem_id,
          event_id: this.event_id,
          message: this.success_msg,
          // image: "USER_IMAGE_URL",
          event_name: this.event_name,
          event_address: this.address,
          event_image: "https://aieventzo.com/upload/event_image/" + this.event_image,
          card_image: this.formData.id_card,
          submitType: submit_type
        }
      }
    });
    console.log('Navigating with:', {
      name: this.formData.name,
      mem_id: this.formData.mem_id,
      event_id: this.event_id,
      message: this.success_msg,
      // image: "USER_IMAGE_URL",
      event_name: this.event_name,
      event_address: this.address,
      event_date: this.from_date,
      event_image: "https://aieventzo.com/upload/event_image/" + this.event_image,
      card_image: this.formData.id_card,
      submitType: submit_type
    });
  }
}
